 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9780292747388_01_COVER from '@/components/html/9780292747388_01_cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9780292747388_02_HTIT from '@/components/html/9780292747388_02_htit'
 import HTML9780292747388_03_TIT from '@/components/html/9780292747388_03_tit'
 import HTML9780292747388_04_COPY from '@/components/html/9780292747388_04_copy'
 import HTML9780292747388_05_FM from '@/components/html/9780292747388_05_fm'
 import HTML9780292747388_06_TOC from '@/components/html/9780292747388_06_toc'
 import HTML9780292747388_07_IN from '@/components/html/9780292747388_07_in'
 import HTML9780292747388_08_CH1 from '@/components/html/9780292747388_08_ch1'
 import HTML9780292747388_09_CH2 from '@/components/html/9780292747388_09_ch2'
 import HTML9780292747388_10_CH3 from '@/components/html/9780292747388_10_ch3'
 import HTML9780292747388_11_CH4 from '@/components/html/9780292747388_11_ch4'
 import HTML9780292747388_12_CH5 from '@/components/html/9780292747388_12_ch5'
 import HTML9780292747388_13_CH6 from '@/components/html/9780292747388_13_ch6'
 import HTML9780292747388_14_CH7 from '@/components/html/9780292747388_14_ch7'
 import HTML9780292747388_15_CH8 from '@/components/html/9780292747388_15_ch8'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9780292747388_16_APP1 from '@/components/html/9780292747388_16_app1'
 import HTML9780292747388_17_APP2 from '@/components/html/9780292747388_17_app2'
 import HTML9780292747388_18_REF from '@/components/html/9780292747388_18_ref'
 import HTML9780292747388_19_INDEX from '@/components/html/9780292747388_19_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780292747388_06_toc",
 			"name" : "html/9780292747388_06_toc",
 			"component" : HTML9780292747388_06_TOC
 		},
 		{
 			"path" : "/html/9780292747388_07_in",
 			"name" : "html/9780292747388_07_in",
 			"component" : HTML9780292747388_07_IN
 		},
 		{
 			"path" : "/html/9780292747388_08_ch1",
 			"name" : "html/9780292747388_08_ch1",
 			"component" : HTML9780292747388_08_CH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js